/* eslint-disable eol-last */
import React from 'react';
import { Grid } from '@mui/system';

function HeroSection({ heroSection }) {
  return (
    <div style={{ backgroundImage: `url(${heroSection?.backgroundImage?.url})` }}>
      <Grid
        container
        className="hero-section"
        sx={{ justifyContent: 'space-between' }}
        rowSpacing={{ sm: 6 }}
      >
        <Grid size={{ xs: 12, sm: 7, md: 6.5 }}>
          <h1 className="title">{heroSection?.title}</h1>
          <h5 className="subTitle">{heroSection?.subTitle}</h5>
        </Grid>
        <Grid className="social-icons-wrap">
          {heroSection?.socialLink?.map((social) => (
            <div className="social-icons" key={social?.id}>
              <a href={social?.url} target="_blank" rel="noreferrer">
                <img src={`${social?.icon?.url}`} alt={social?.icon?.name} />
              </a>
            </div>
          ))}
        </Grid>
      </Grid>
    </div>
  );
}

export default HeroSection;
